module.exports = __webpack_public_path__ + "img/98ne.cda2208b.svg";